export default "__VITE_ASSET__DC4tmT1v__"